<template>
  <div v-if="currentUser">
    <div class="row">
      <div class="col-8">
        <v-server-table
          ref="table"
          :columns="columns"
          :options="options"
          :url="`/supporting-documents?user_id=${currentUser.id}`"
        />
      </div>
      <div class="col-4">
        <b-form @keydown="form.errors.clear($event.target.name)" @submit.prevent="onSubmit">
          <b-card>
            <template #header>Upload <strong>Supporting Documents</strong></template>

            <div :class="form.errors.has('url') ? 'invalid-wrapper' : ''" class="form-row">
              <label class="col-3 col-form-label mb-2 text-right">Document</label>
              <div class="col-8 mb-3 uploader-button">
                <div v-show="form.url.length === 0">
                  <file-uploader :data="{ user_id: currentUser.id }" @uploaded="documentUploaded">
                    <font-awesome-icon :icon="['fal', 'cloud-upload']" />
                    Attach File
                  </file-uploader>
                </div>
                <div v-show="form.url.length > 0">
                  <file-object :href="form.url"> File Uploaded</file-object>
                  <button class="btn btn-xsm btn-danger ml-1" @click.prevent="form.url = ''">
                    <font-awesome-icon :icon="['fal', 'times']" />
                    Remove
                  </button>
                </div>
                <div class="invalid-feedback" v-text="form.errors.get('url')"></div>
              </div>
            </div>

            <div :class="form.errors.has('type') ? 'invalid-wrapper' : ''" class="form-row">
              <label class="col-3 col-form-label mb-2 text-right">Type</label>
              <div class="col-8 mb-3">
                <div>
                  <multiselect
                    v-model.trim="form.type"
                    :close-on-select="true"
                    :options="supportingDocumentTypes"
                    :show-labels="false"
                    :taggable="true"
                    @input="form.errors.clear('type')"
                  />
                </div>
                <div class="invalid-feedback" v-text="form.errors.get('type')"></div>
              </div>
            </div>

            <form-date
              v-model="form.expiry"
              name="expiry"
              value-format="yyyy-MM-dd"
              @input="form.errors.clear()"
            />

            <div class="row">
              <div class="col-11 text-right">
                <button :disabled="!formValid || form.busy" class="btn btn-primary">
                  <font-awesome-icon v-if="form.busy" :icon="['fal', 'spinner']" spin />
                  <font-awesome-icon v-else :icon="['fal', 'plus-circle']" />
                  Add
                </button>
              </div>
            </div>
          </b-card>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import moment from "moment";
import format from "../../../mixins/format";
import entity from "../../../mixins/entity";
import FileUploader from "../../../components/common/FileUploader.vue";

const supportingDocumentTypes = [
  "CV",
  "Contract",
  "Banking Details",
  "Cablers License",
  "Certificate of Currency",
  "Direct Debit Form",
  "Disclosure Doc Receipt",
  "Drivers License",
  "Franchise Agreement",
  "Matchmaster Account Form",
  "OH&S Manual Receipt",
  "Operations Manual Receipt",
  "Pest License",
  "Police check",
  "Professional Indemnity",
  "Public Liability Certificate",
  "Safety Harness Photo",
  "Security License",
  "Technician Registration Form",
  "Termite License",
  "Vaccination Certificate",
  "Van Registration",
  "Vehicle Insurance Certificate",
  "Vehicle Photos & Details",
  "White Card",
  "Working at Heights Certificate",
  "Working with Children",
];

export default {
  components: {
    FileUploader,
  },
  mixins: [entity, format],

  props: {
    currentUser: {
      required: true,
    },
  },

  data() {
    return {
      supportingDocumentTypes,

      columns: ["url", "type", "expiry", "delete"],
      options: {
        headings: {
          url: () => "Document",
        },

        filterable: [],

        templates: {
          url: (h, o) =>
            h("file-object", {
              props: {
                href: o.url,
              },
            }),
          expiry: (h, o) => this.formatLocalDate(o.expiry, "DD/MM/YYYY"),
          delete: (h, o) => this.entityDelete(h, o, "supporting-documents", this.$refs),
        },

        rowClassCallback(row) {
          const diff = moment().diff(moment(row.expiry, "YYYY-MM-DD"), "days");

          if (diff && diff > 0) {
            return "expired";
          }

          return "";
        },
      },

      form: new window.AppForm({
        id: "",
        user_id: "",
        type: "",
        expiry: "",
        url: "",
      }),
    };
  },

  computed: {
    formValid() {
      return this.form.url.length > 0 && this.form.type.length > 0;
    },
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.form.user_id = this.currentUser.id;
      this.form.type = "";
      this.form.expiry = "";
      this.form.url = "";
    },

    documentUploaded(url) {
      this.form.url = url;
    },

    onSubmit() {
      this.form.post("/supporting-documents").then(() => {
        window.toastr.success("Supporting document added!", "Success");

        this.init();

        this.$nextTick(() => {
          this.$refs.table.query = "";
          this.$refs.table.refresh();
        });
      });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.uploader-button {
  line-height: 37px;
  min-height: 37px;
}

.uploader-button .badge {
  position: relative;
  top: 1px;
}
</style>
